export const changeFavicon = (path) => {
  const link = document.querySelector('link[rel=\'icon\']')
  link.href = path
  document.getElementsByTagName('head')[0].appendChild(link)
}
